
const Nav = () => {
  
       return (
         <nav className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
           <a className="navbar-brand col-md-3 col-lg-2 me-0 px-3" href="#">Expense App</a>
        
           <div className="navbar-nav">
             <div className="nav-item text-nowrap">
               <p className="nav-link px-3"></p>
             </div>
           </div>
         </nav>
       );
   }


export default Nav;